import { render, staticRenderFns } from "./LayoutNijmegen.vue?vue&type=template&id=0134d2f1&"
import script from "./LayoutNijmegen.vue?vue&type=script&lang=js&"
export * from "./LayoutNijmegen.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNijmegen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports